// Module
var code = "<label>{{::vm.label}}</label>\r\n<mx-conditions-builder conditions-builder=\"vm.builder\" ng-if=\"vm.builder\"></mx-conditions-builder>\r\n<mx-control-errors></mx-control-errors>";
// Exports
export default code;